import {
  Box,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useBreakpointValue,
} from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';
import { ResearchShowsSt } from '@ieo/Common/CompLangConfig';
import { nanoid } from 'nanoid';

const IeoBenefitsV8Modal = ({
  isOpen,
  onClose,
  btnRef,
  sectionContent,
  lang,
}) => {
  return (
    <Modal
      w={{ md: '808px', base: '321px' }}
      h={{ md: '85vh', base: 'auto' }}
      isOpen={isOpen}
      onClose={onClose}
      size={useBreakpointValue({ base: 'full', md: '808px' })}
      finalFocusRef={btnRef}
      background="#F1EBDF"
    >
      <ModalOverlay />
      <ModalContent
        borderRadius="0px"
        background="#F1EBDF"
        w="100%"
        maxW={{ base: '100%', md: '746px', lg: '808px' }}
        my={{ base: '0', md: '8px' }}
        h={{ base: '95%', md: '97%' }}
        overflow="hidden"
      >
        <ModalHeader mt={{ base: '13px', md: 'calc(1rem + 20px)' }} pt="0">
          <Heading
            as="h3"
            pt={{ base: '10px', md: 0 }}
            {...ResearchShowsSt[lang]?.h3}
          >
            {sectionContent[9]?.titleText}
          </Heading>
        </ModalHeader>
        <ModalCloseButton
          mt="10px"
          color="E86F34"
          top={{ base: 1, md: 5 }}
          background="transparent"
          _hover={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _active={{
            background: 'transparent',
            boxShadow: 'none',
          }}
          _focus={{
            background: 'transparent',
            boxShadow: 'none',
          }}
        >
          <Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 20.4143L12 13.4143L4.99997 20.4143L3.58576 19.0001L10.5858 12.0001L3.58576 5.00009L4.99997 3.58588L12 10.5859L19 3.58588L20.4142 5.00009L13.4142 12.0001L20.4142 19.0001L19 20.4143Z"
                fill="#E86F34"
              />
            </svg>
          </Box>
        </ModalCloseButton>
        <ModalBody pr={{ base: '12px', md: 6 }} pl={{ base: '32px', md: 6 }}>
          <Box pb={{ base: '0', md: '0', lg: '30px' }} background="#F1EBDF">
            <Flex
              flexWrap="wrap"
              w="100%"
              justifyContent={{ base: 'start', lg: 'start' }}
              alignItems={{ base: 'start', lg: 'start' }}
              maxH={{ base: '85vh', md: '80vh' }}
              h="100%"
              overflowY="auto"
              pr={{ base: '16px', md: '16px' }}
              className="customScrollbar"
            >
              {sectionContent[10]?.cards?.map((card, index) => {
                return (
                  <Box
                    w="100%"
                    key={nanoid()}
                    borderBottom={{
                      base:
                        index === sectionContent[10]?.cards?.length - 1
                          ? '0px solid'
                          : 'solid 1px #C5BFB1',
                      md: 'none',
                    }}
                  >
                    <Flex
                      m={{
                        base: '0 0px 0 0px',
                        md: '0 0px 0 10px',
                        lg: '0 0px 0 0px',
                      }}
                      p={{
                        base: '0 0px 0 0px',
                        md: '0 10px 0 0px',
                      }}
                      flexGrow="1"
                      justifyContent={{
                        base: 'center',
                        md: 'start',
                      }}
                      alignItems={{
                        base: 'center',
                        md: 'start',
                      }}
                    >
                      <Box w="100px" height="100%">
                        <LazyLoadImageComponent
                          objectFit="cover"
                          w="100%"
                          h="100%"
                          maxW="65px"
                          src={card.image?.image?.url}
                          alt={card.image?.image?.alt}
                          title={card.image?.image?.title}
                          mt="15px"
                        />
                      </Box>
                      <Box
                        borderBottom={{
                          base: 'none',
                          md: 'solid 1px #C5BFB1',
                        }}
                        w={{
                          base: 'calc(100% - 5%)',
                          md: 'calc(100% - 100px)',
                        }}
                      >
                        <StructuredTextParser
                          {...ResearchShowsSt[lang].popUpTitle}
                          // ml={{ base: '55px' }}
                          str={render(card?.image?.description?.value)}
                        />
                        <StructuredTextParser
                          display={{
                            base: 'none',
                            md: 'block',
                          }}
                          {...ResearchShowsSt[lang].popUpDesc}
                          pt="5px"
                          pb="20px"
                          str={render(card?.description.value)}
                          className="textPmark"
                        />
                      </Box>
                    </Flex>
                    <StructuredTextParser
                      display={{
                        base: 'block',
                        md: 'none',
                      }}
                      {...ResearchShowsSt[lang].popUpDesc}
                      pt="5px"
                      pb="10px"
                      str={render(card?.description.value)}
                    />
                  </Box>
                );
              })}
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default IeoBenefitsV8Modal;
